import { Factory } from 'rosie';

Factory.define('AgentAssistanceConfig').attr('topicSuggestions', false);



// WEBPACK FOOTER //
// ./factories/agent_assistance_config.js